import React from 'react';
import {
  StyledSummaryChart,
  SummaryChartRange,
  SummaryChartStat,
  SummaryChartStatLabel,
  SummaryChartStats,
  SummaryChartStatValue,
  SummaryChartTitle,
} from './SummaryChartStyles';
import { MgpGaugeChart } from '../../components/MgpGaugeChart/MgpGaugeChart';
import LoadingMask from '../../../CommonComponents/LoadingMask';

interface Props {
  title: string;
}

export const SummaryChartLoading: React.FC<Props> = ({ title }) => {
  return (
    <StyledSummaryChart>
      <SummaryChartTitle>{title}</SummaryChartTitle>
      <>
        <SummaryChartStats>
          <SummaryChartStat>
            <SummaryChartStatLabel>Average Return</SummaryChartStatLabel>
            <SummaryChartStatValue>
              <LoadingMask width="100px" height="20px" isDark />
            </SummaryChartStatValue>
          </SummaryChartStat>
          <SummaryChartStat>
            <SummaryChartStatLabel>Bad Timing</SummaryChartStatLabel>
            <SummaryChartStatValue>
              <LoadingMask width="100px" height="20px" isDark />
            </SummaryChartStatValue>
          </SummaryChartStat>
        </SummaryChartStats>
        <MgpGaugeChart />
        <SummaryChartRange>
          <LoadingMask width="200px" height="20px" isDark />
        </SummaryChartRange>
      </>
    </StyledSummaryChart>
  );
};
